import { Routes } from '@angular/router';
import { AuthenticationGuard, ProfileCompletionGuard } from '../directives';
import {
    HomeComponent, LoginComponent, PlaylistsComponent, SongsComponent, DashboardComponent, Four04Component,
    SignupComponent, LifestyleComponent, DemographicComponent, NotificationComponent, BillingComponent, ForgotScreennameComponent,
    RequestPasswordResetComponent, PlaylistDetailComponent, MyDiscoveriesComponent, MyMusicLibraryComponent,
    RecentLicensesComponent, ArtistDetailComponent, AlbumDetailComponent, ArtistsComponent, AlbumsComponent,
    SongDetailPageComponent, UserDetailComponent, UserListComponent, ResetPasswordComponent, AboutUsComponent,
    PrivacyPolicyComponent, SupportComponent, HomeSupportComponent, HomeDiscoverComponent, HomeGetpaidComponent,
    PaymentInfoComponent, MyDownloadsComponent, MyPackageComponent, PaymentHistoryComponent, PackageDetailComponent,
    UserActivityComponent, AllArtistComponent, DASHBOARD_TAB_ROUTES, ProfileComponent, SearchPageComponent, ViewCartComponent, CheckoutComponent, MyReportsComponent,
    SongsSearchOnCreditsComponent

} from './index';
import { AdvancedSearchComponent } from "./advanced-search/advanced-search.component";
import { SurveyComponent } from './survey/survey.component';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        data: {
            title: 'Home'
        }
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'Login'
        }
    },
    {
        path: 'login/verified',
        component: LoginComponent,
        data: { verified: true, title: 'Login' }
    },
    {
        path: 'login/failed',
        component: LoginComponent,
        data: { failed: true, title: 'Login' }
    }, {
        path: 'login/already',
        component: LoginComponent,
        data: { already: true, title: 'Login' }
    },

    {
        path: 'forgot-screenname',
        component: ForgotScreennameComponent,
        data: {
            title: 'Forgot'
        }
    },
    {
        path: 'request-password-reset',
        component: RequestPasswordResetComponent,
        data: {
            title: 'Reset'
        }
    },
    {
        path: 'request-password-reset/mail-sent',
        component: RequestPasswordResetComponent,
        data: { done: true, title: 'Reset' }
    },
    {
        path: 'signup',
        component: SignupComponent,
        data: {
            title: 'Signup'
        }
    },
    {
        path: 'signup/done',
        component: SignupComponent,
        data: { done: true, title: 'Signup' }
    },
    {
        path: 'signup/direct',
        component: SignupComponent,
        data: { direct: true, title: 'Signup' }
    },
    {
        path: 'signup/request',
        component: SignupComponent,
        data: { request: true, title: 'Signup' }
    },
    {
        path: 'demographic-profile',
        component: DemographicComponent,
        data: {
            title: 'Semographic Profile'
        }
    },
    {
        path: 'notification-setting',
        component: NotificationComponent,
        data: {
            title: 'Notification Setting'
        }
    },
    {
        path: 'billing-profile',
        component: BillingComponent,
        data: {
            title: 'Billing Profile'
        }
    },
    {
        path: 'lifestyle-profile',
        component: LifestyleComponent,
        data: {
            title: 'Lifestyle Profile'
        }
    },
    {
        path: 'payment-info',
        component: PaymentInfoComponent,
        data: {
            title: 'Payment Info'
        }
    },
    {
        path: 'payment-info-update',
        component: PaymentInfoComponent,
        data: { update: true, title: 'Payment Info' }
    },
    {
        path: 'newest-music',
        component: SongsComponent,
        data: {
            type: 'NM',
            title: 'Newest Music',
            domain: 'NM'
        }
    },
    {
        path: 'most-played',
        component: SongsComponent,
        data: {
            type: 'MP',
            title: 'Most Played',
            domain: 'MP'
        }
    },
    {
        path: 'playlists',
        component: PlaylistsComponent,
        canActivate: [AuthenticationGuard],
        data: {
            type: 'P',
            title: 'My Playlists',
            domain: 'P'
        }
    },
    {
        path: 'playlists/:PlaylistSlug',
        component: PlaylistsComponent,
        canActivate: [AuthenticationGuard],
        data: {
            type: 'P',
            title: 'My Playlists',
            domain: 'P'
        }
    },
    {
        path: 'listening',
        component: MyReportsComponent,
        canActivate: [AuthenticationGuard],
        data: {
            title: 'Listening',
        }
    },
    {
        path: 'weget-official',
        component: PlaylistsComponent,
        data: {
            type: 'WF',
            title: 'WeGet Official',
            domain: 'WF'
        }
    },
    {
        path: 'radio',
        component: PlaylistsComponent,
        canActivate: [AuthenticationGuard],
        data: {
            type: 'R',
            title: 'Radio',
            domain: 'R'
        }
    },
    {
        path: 'genres-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'G',
            title: 'Genres Playlists',
            domain: 'G'
        }
    },
    {
        path: 'fans-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'F',
            title: 'Fans Playlists',
            domain: 'F'
        }
    },
    {
        path: 'industry-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'IP',
            title: 'Industry Playlists',
            domain: 'IP'
        }
    },
    {
        path: 'official-soundtracks',
        component: PlaylistsComponent,
        data: {
            type: 'OST',
            title: 'Official Soundtracks',
            domain: 'OST'
        }
    },
    {
        path: 'podcasts',
        component: PlaylistsComponent,
        data: {
            type: 'PCT',
            title: 'Podcasts',
            domain: 'PCT'
        }
    },
    {
        path: 'books',
        component: PlaylistsComponent,
        data: {
            type: 'BK',
            title: 'Books',
            domain: 'BK'
        }
    },
    {
        path: 'activities-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'Ac',
            title: 'Activity Playlists',
            domain: 'AC'
        }
    },
    {
        path: 'in-memory-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'IM',
            title: 'In Memory Playlists',
            domain: 'IM'
        }
    },
    {
        path: 'giving-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'NP',
            title: 'Giving Playlists',
            domain: 'NP'
        }
    },
    {
        path: 'music-for-movies',
        component: PlaylistsComponent,
        data: {
            title: 'Music For Movies',
            type: 'M',
            domain: 'M'
        }
    },
    {
        path: 'time-period',
        component: PlaylistsComponent,
        data: {
            title: 'Time Period',
            type: 'TP',
            domain: 'TP'
        }
    },
    {
        path: 'composers',
        component: PlaylistsComponent,
        data: {
            title: 'Composers',
            type: 'M',
            domain: 'M'
        }
    },
    {
        path: 'business-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'B',
            title: 'Business Playlists',
            domain: 'B'
        }
    },
    {
        path: 'gamers',
        component: PlaylistsComponent,
        data: {
            type: 'GP',
            title: 'Gamers Playlists',
            domain: 'GP'
        }
    },
    {
        path: 'musicsupervisor',
        component: PlaylistsComponent,
        data: {
            type: 'MS',
            title: 'Musicsupervisor Playlists',
            domain: 'MS'
        }
    },
    {
        path: 'my-radio',
        component: PlaylistsComponent,
        canActivate: [AuthenticationGuard],
        data: {
            type: 'MR',
            title: 'My Radio',
            domain: 'MR'
        }
    },
    {
        path: 'peoples-playlists',
        component: PlaylistsComponent,
        data: {
            type: 'search',
            title: 'Playlists'
        }
    },
    {
        path: 'playlist/:id',
        component: PlaylistDetailComponent,
        data: {
            domain: 'P-D',
            title: 'Playlist Detail'
        }
    },
    {
        path: 'P/:id',
        component: PlaylistDetailComponent,
        data: {
            domain: 'P-D',
            title: 'Playlist detail'
        }
    },
    {
        path: 'P/:user_id/:id',
        component: PlaylistDetailComponent,
        data: {
            domain: 'P-D',
            title: 'Playlist detail'
        }
    },
    // for demoplayer page of raio. to do delete, start here
    {
        path: 'radio/:id',
        component: PlaylistsComponent,
        data: {
            type: 'R',
            title: 'Radio',
            domain: 'R',
            id: 'id'
        }
    },
    // end here
    {
        path: 'R/:id',
        component: PlaylistDetailComponent,
        data: {
            domain: 'P-D',
            title: 'Playlist detail'
        }
    },
    {
        path: 'my-music',
        component: SongsComponent,
        data: {
            title: 'My Music'
        },
        canActivate: [AuthenticationGuard],
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        children: DASHBOARD_TAB_ROUTES
    },
    {
        path: 'my-music-library',
        component: MyMusicLibraryComponent,
        canActivate: [AuthenticationGuard],
        data: {
            title: 'My Music Library'
        }
    },
    {
        path: 'my-discoveries',
        canActivate: [AuthenticationGuard],
        component: MyDiscoveriesComponent,
        data: {
            domain: 'DS',
            title: 'My Discoveries'
        }
    },
    {
        path: 'discover-new-music',
        component: PlaylistsComponent,
        data: {
            type: 'DM',
            title: 'Discover New Music',
            domain: 'DM'
        }
    },
    {
        path: 'global-discoveries',
        component: PlaylistsComponent,
        data: {
            type: 'DM',
            title: 'Global Discoveries',
            domain: 'DM'
        }
    },
    {
        path: 'advanced-search',
        component: AdvancedSearchComponent,
        data: {
            title: 'Production Credit Search'
        }
    },

    {
        path: 'most-downloaded',
        component: SongsComponent,
        data: {
            type: 'MD',
            title: 'Most Downloaded',
            domain: 'MD'
        }
    },
    {
        path: 'recent-licenses',
        component: PlaylistsComponent, //RecentLicensesComponent,
        data: {
            type: 'L',
            title: 'Recent Licenses',
            domain: 'L'
        }
    },
    {
        path: 'artist/:artistSlug',
        component: ArtistDetailComponent,
        data: {
            domain: 'A-D',
            title: 'Artist Detail'
        }
    },
    {
        path: 'A/:artistSlug',
        component: ArtistDetailComponent,
        data: {
            domain: 'A-D',
            title: 'Artist Detail'
        }
    },
    {
        path: 'A/:user_id/:artistSlug',
        component: ArtistDetailComponent,
        data: {
            domain: 'A-D',
            title: 'Artist Detail'
        }
    },
    {
        path: 'collection/:albumSlug',
        component: AlbumDetailComponent,
        data: {
            domain: 'C-D',
            title: 'Album Detail'
        }
    },
    {
        path: 'songs',
        component: SongsComponent,
        data: {
            type: 'search',
            title: 'Songs',
            domain: 'S'
        }
    },
    {
        path: 'songssearchoncredits',
        component: SongsSearchOnCreditsComponent,
        data: {
            type: 'CS',
            title: 'Production Credits Search',
            domain: 'S'
        }
    },
    {
        path: 'credits',
        component: SongsComponent,
        data: {
            type: 'credits',
            title: 'Credits Search',
            domain: 'PC'
        }
    },
    {
        path: 'artists',
        component: ArtistsComponent,
        data: {
            type: 'search',
            title: 'Artists',
            domain: 'A'
        }
    },
    {
        path: 'allArtists',
        component: AllArtistComponent,
        data: {
            type: 'search',
            title: 'Artists',
            domain: 'A'
        }
    },
    {
        path: 'collections',
        component: AlbumsComponent,
        data: {
            type: 'search',
            title: 'Collections',
            domain: 'C'
        }
    },
    {
        path: 'accounts',
        component: UserListComponent,
        data: {
            type: 'search',
            title: 'Users',
            domain: 'U'
        }
    },
    {
        path: 'song/:songSlug',
        component: SongDetailPageComponent,
        data: {
            type: 'songDetailPage',
            domain: 'S-D',
            title: 'Song Detail'
        }
    },
    {
        path: 'S/:user_id/:songSlug',
        component: SongDetailPageComponent,
        data: {
            type: 'songDetailPage',
            domain: 'SS',
            title: 'Song Detail'
        }
    },

    {
        path: 'S/:songSlug',
        component: SongDetailPageComponent,
        data: {
            type: 'songDetailPage',
            domain: 'SS',
            title: 'Song Detail'
        }
    },
    {
        path: 'account/:screenname',
        component: UserDetailComponent,
        data: {
            domain: 'U',
            title: 'User Detail'
        }
    },
    {
        path: 'request-password-reset/:token',
        component: ResetPasswordComponent,
        data: {
            title: 'Request Password'
        }
    },
    {
        path: 'signup/referral_code/:referral_code',
        component: SignupComponent,
        data: {
            title: 'Signup'
        }
    },
    {
        path: 'signup/verify/:token',
        component: LoginComponent,
        data: {
            title: 'Signup'
        }
    },
    {
        path: 'support',
        component: SupportComponent,
        data: {
            title: 'Support'
        }
    },
    {
        path: 'terms-and-conditions',
        component: PrivacyPolicyComponent,
        data: {
            title: 'Terms and Conditions'
        }
    },
    {
        path: 'home-support',
        component: HomeSupportComponent,
        data: {
            title: 'Support'
        }
    },
    {
        path: 'home-getpaid',
        component: HomeGetpaidComponent,
        data: {
            title: 'Ge Paid'
        }
    },
    {
        path: 'home-discover',
        component: HomeDiscoverComponent,
        data: {
            title: 'Discover'
        }
    },
    {
        path: 'about',
        component: AboutUsComponent,
        data: {
            title: 'About'
        }
    },
    {
        path: 'my-downloads',
        component: MyDownloadsComponent,
        data: {
            title: 'My Downloads',
            domain: 'DL'
        }
    },
    {
        path: 'payment-history',
        component: PaymentHistoryComponent,
        data: {
            title: 'Payment History'
        }
    },
    {
        path: 'my-packages',
        component: MyPackageComponent,
        data: {
            title: 'My Packages'
        }
    },
    {
        path: 'my-package/:id',
        component: PackageDetailComponent,
        data: {
            title: 'Package Detail'
        }
    },
    {
        path: 'profile',
        component: ProfileComponent,
        data: {
            title: 'Profile'
        }
    },
    {
        path: 'search',
        component: SearchPageComponent,
        data: {
            domain: 'SE',
            title: 'Search'
        }
    },
    {
        path: 'cart',
        component: ViewCartComponent,
        data: {
            title: 'Cart'
        }
    },
    {
        path: 'checkout',
        component: CheckoutComponent,
        canActivate: [AuthenticationGuard],
        data: {
            title: 'Checkout'
        }
    },
    {
        path: 'survey/:id',
        component: SurveyComponent,
    },
    {
        path: '**',
        component: Four04Component,
        data: {
            title: 'Not Found'
        }
    }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts